<template>
  <div class="login mod-back">
    <div>
      <div class="back-button" @click="backToPhone">
        <img src="@/assets/img/auth-left-angle.svg" alt="back">
      </div>
      <div class="login__title">Подтверждение </div>
      <div class="login__description">Мы отправили код на номер</div>
      <div class="login__phone">{{ phone }}</div>
      <div class="login__code-wrapper">
        <div class="login__code">
          <input
            v-for="i in codeLength"
            :key="i"
            ref="code"
            v-model="code[i-1]"
            v-mask="'#'"
            class="login__code-item"
            :class="[{ success: isSuccess }, { error: hasError } ]"
            @focus="clearValue(i)"
            @input="enterValue(i)"/>
        </div>
        <transition>
          <div v-if="hasError" class="input__error">
            <div class="input__error-image">
              <img src="@/assets/img/new-error.svg" alt="error">
            </div>
            <p class="input__error-text">СМС-код введен неверно</p>
          </div>
        </transition>
      </div>
    </div>
    <div>
      <new-button
        v-if="!isSuccess"
        :title="buttonTitle"
        :type="buttonStyle"
        width="fullWidth"
        @button-clicked="resendCode"
      />
    </div>
    <el-dialog
      :visible.sync="needAgree"
      width="100%"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      class="login__confirmation"
    >
      <div class="login__confirmation-title">
        Политика конфиденциальности <br>
        и Условия использования
      </div>
      <div class="login__confirmation-content">
        Выбрав вариант “Принимаю” Вы соглашаетесь <br> с
        <a href="/terms" class="confirmation__link" target="_blank">Условиями использования</a>
      </div>
      <div class="login__confirmation-content">
        Вы также соглашаетесь с положением <br>
        <a href="/privacy" class="confirmation__link" target="_blank">Политики конфиденциальности</a>
      </div>
      <span slot="footer" class="dialog-footer">
        <new-button
          title="Принимаю"
          type="primary"
          width="fullWidth"
          @button-clicked="goRegistration"
        />
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { CODE_LENGTH } from './const'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mapActions, mapGetters } from 'vuex'
import NewButton from '@/components/Drivers/NewButton/NewButton'

const Auth = RepositoryFactory.get('auth')

export default {
  name: 'AuthCode',
  components: { NewButton },
  props: {
    phone: {
      type: String,
      default: '',
    },
    isRegistered: {
      type: Boolean,
      default: false,
    },
    timerInterval: {
      type: Number,
      default: 120,
    },
  },
  data() {
    return {
      code: [],
      isFullCode: false,
      hasError: false,
      isButtonTimer: true,
      timerId: null,
      timerValue: 0,
      codeLength: CODE_LENGTH,
      needAgree: false,
    }
  },
  computed: {
    ...mapGetters({
      authStatus: 'auth/authStatus',
    }),
    isSuccess() {
      return this.code.length === this.codeLength && !this.hasError && this.isFullCode
    },
    buttonTitle() {
      if (this.isButtonTimer) {
        let minutes = Math.trunc(this.timerValue / 60)
        let minutesText = minutes < 10 ? '0' + String(minutes) : minutes
        let seconds = this.timerValue % 60
        let secondsText = seconds < 10 ? '0' + String(seconds) : seconds

        return `Запросить через ${minutesText}:${secondsText}`
      }

      return 'Запросить код еще раз'
    },
    buttonStyle() {
      return (this.isButtonTimer && !this.isSuccess)
        ? 'secondary not-allowed'
        : 'primary'
    },
  },
  watch: {
    isSuccess() {
      if (this.isSuccess) {
        this.onSubmit()
      }
    },
    authStatus() {
      if (this.authStatus === 'success') {
        if (this.isRegistered) {
          this.$router.push({ name: 'Home' })
        } else {
          this.$emit('new-user')
        }
      } else {
        this.hasError = true
      }
    },
  },
  mounted() {
    this.$refs.code[0].focus()
    this.startTimer()
  },
  beforeDestroy() {
    clearInterval(this.timerId)
  },
  methods: {
    ...mapActions({
      login: 'auth/authLogin',
    }),
    startTimer() {
      this.timerValue = this.timerInterval
      this.isButtonTimer = true
      this.timerId = setInterval(() => {
        this.timerValue--
      }, 1000)
      setTimeout(() => {
        clearInterval(this.timerId)
        this.isButtonTimer = false
      },
        this.timerValue * 1000)
    },
    enterValue(index) {
      this.hasError = false
      if (!this.code[index - 1].match(/[\d]/)) {
        this.code[index - 1] = ''
        return false
      }
      if (index < this.codeLength) {
        this.$refs.code[index].focus()
      } else {
        this.isFullCode = true
        this.$refs.code[index - 1].blur()
      }
    },
    clearValue(index) {
      this.isFullCode = false
      this.code[index - 1] = ''
    },
    onSubmit() {
      if (this.isRegistered) {
        this.tryLogin()
        // таймаут чисто чтобы зеленую рамку на инпутах успели рассмотреть
        setTimeout(() => (this.code = []), 300)
      } else {
        this.needAgree = true
      }
    },
    goRegistration() {
      this.needAgree = false
      this.tryLogin()
    },
    tryLogin() {
      const code = this.code.join('')
      const login = this.phone

      this.login({ login, code })
    },
    resendCode() {
      if (!this.isButtonTimer) {
        this.startTimer()
        Auth.getcode(this.phone)
          .catch(err => this.errHandler(err))
        this.hasError = false
        this.code = []
      }
    },
    backToPhone() {
      this.code = []
      this.$emit('back-phone')
    },
  },
}
</script>

<style lang="sass" scoped>
@import "~@/assets/styles/mixins.sass"
.login.mod-back
  padding-top: 4rem

.back-button
  display: flex
  justify-content: center
  align-items: center
  width: 3.4rem
  height: 3.4rem
  margin-bottom: 2rem
  cursor: pointer
  border-radius: 0.8rem
  background: #EFEFEF
  img
    width: 1.8rem
    height: 1.8rem
.login__phone
  margin: 0.8rem 0 4rem
  font-size: 1.4rem
  line-height: 1.8rem
  color: #181818
.login__code-wrapper
  padding: 0 3rem
.login__code
  display: flex
  justify-content: space-between
  align-items: center

  &-item
    width: 5.8rem
    height: 5.7rem
    padding-left: 2rem
    font-family: 'Mulish', sans-serif
    font-size: 2.6rem
    font-weight: 800
    line-height: 3.4rem
    box-sizing: border-box
    background: #F8F8F8
    border: none
    border-radius: .9rem
    outline: none
    // disable arrows
    -moz-appearance: textfield
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button
      -webkit-appearance: none

    @include from(420px)
      width: 66px
      height: 66px
      padding-left: 20px
      font-size: 38px

    &:focus
      border: 1px solid #FF7F37

    &.success
      border: 1px solid #28B411

    &.error
      background: #FFF2F2
      border: 1px solid #ED2121

.login__confirmation
  &-title
    margin-bottom: 2rem
    font-size: 2rem
    font-weight: 800
    line-height: 2.8rem
    color: #181818
  &-content
    margin-bottom: 1.2rem
    font-size: 1.4rem
    line-height: 1.8rem
    color: #747474
    .confirmation__link
      color: $mainColor
      &:hover
        color: #00833C
        text-decoration: underline
      &:active
        color: #006421
        text-decoration: underline

  ::v-deep .el-dialog
    position: absolute
    bottom: 0
    margin-bottom: 0
    border-radius: 12px 12px 0 0 !important
    &__header
      display: none
    &__body
      padding: 3.2rem 1.6rem 2rem
    &__footer
      padding: 0 1.6rem 4rem
      border-top: none
      button
        margin-top: 0
::v-deep .v-modal
  background: #2B2B2B
  opacity: .7
</style>
